import { useState } from "react";

const FORM_URL = "https://readdy.ai/api/form/db7479en6nb9f68e9970";

export default function ContactForm() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const payload = new FormData(form);
    const honeypot = String(payload.get("contact_alt") || "").trim();

    if (honeypot) {
      setStatus("success");
      setMessage("留言已提交，感谢你的反馈，我们会尽快回复。");
      form.reset();
      return;
    }

    payload.delete("contact_alt");
    setStatus("loading");
    try {
      const body = new URLSearchParams();
      payload.forEach((value, key) => {
        body.append(key, String(value));
      });
      const response = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || responseText;
      const isSpam = typeof serverMsg === "string" && serverMsg.toLowerCase().includes("spam");
      if (response.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        setMessage("留言已提交，感谢你的反馈，我们会尽快回复。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(
          typeof serverMsg === "string" && serverMsg.length > 0 ? serverMsg : "提交失败，请稍后重试。"
        );
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后重试。");
    }
  };

  return (
    <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="flex flex-col gap-4">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <label className="flex flex-col gap-2">
          <span className="text-sm font-medium text-foreground-700">你的称呼</span>
          <input
            type="text"
            name="name"
            required
            placeholder="请输入称呼"
            className="h-11 rounded-lg border border-foreground-200 bg-background-50 px-4 text-sm text-foreground-950 outline-none placeholder:text-foreground-400 focus:border-primary-400"
          />
        </label>
        <label className="flex flex-col gap-2">
          <span className="text-sm font-medium text-foreground-700">邮箱地址</span>
          <input
            type="email"
            name="email"
            required
            placeholder="name@example.com"
            className="h-11 rounded-lg border border-foreground-200 bg-background-50 px-4 text-sm text-foreground-950 outline-none placeholder:text-foreground-400 focus:border-primary-400"
          />
        </label>
      </div>
      <input
        className="hp-field-1993"
        type="text"
        name="contact_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />
      <label className="flex flex-col gap-2">
        <span className="text-sm font-medium text-foreground-700">想对我们说的话</span>
        <textarea
          name="content"
          required
          maxLength={500}
          rows={5}
          placeholder="欢迎分享你的建议、合作意向或想看到的搭配主题（500 字以内）"
          className="resize-none rounded-lg border border-foreground-200 bg-background-50 px-4 py-3 text-sm text-foreground-950 outline-none placeholder:text-foreground-400 focus:border-primary-400"
        />
      </label>
      <button
        type="submit"
        disabled={status === "loading"}
        className="h-12 w-full whitespace-nowrap rounded-lg bg-foreground-950 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-60 cursor-pointer sm:w-fit sm:px-8"
      >
        {status === "loading" ? "提交中…" : "提交留言"}
      </button>
      {status !== "idle" && status !== "loading" && (
        <p className={`text-sm ${status === "success" ? "text-primary-600" : "text-primary-700"}`}>{message}</p>
      )}
    </form>
  );
}